import { useState } from 'react'
import { Button, Modal } from '../ui'

export const AlertDialogEjectUser = ({ participant, onConfirm, trigger }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    setLoading(true)
    await onConfirm(participant.id)
    setLoading(false)
    setIsOpen(false)
  }

  return (
    <>
      <div onClick={() => setIsOpen(true)} style={{ cursor: 'pointer' }}>
        {trigger}
      </div>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Expulsar participante"
        size="sm"
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '2.5rem',
              height: '2.5rem',
              borderRadius: '50%',
              background: '#fee2e2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.25rem',
              flexShrink: 0,
            }}
          >
            🚫
          </div>
          <p style={{ margin: 0, lineHeight: 1.5 }}>
            ¿Expulsar a{' '}
            <strong>
              {participant.name} {participant.surname}
            </strong>{' '}
            de esta clase? Se liberará su plaza.
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Button
            variant="ghost"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Expulsando...' : 'Expulsar'}
          </Button>
        </div>
      </Modal>
    </>
  )
}
